import { useQuery } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

export const amenitiesQueryKeys = {
  all: ['accommodation', 'amenities'] as const,
  list: () => [...amenitiesQueryKeys.all, 'list'] as const,
};

const AMENITIES_STALE_TIME_MS = 5 * 60 * 1000;

export function useGetAmenities({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: amenitiesQueryKeys.list(),
    queryFn: async () => {
      const response = await ReservationService.getAmenities();
      return response.result ?? [];
    },
    enabled,
    staleTime: AMENITIES_STALE_TIME_MS,
  });
}
